import { TransportationAgency } from '../../company/transportation-agency/transportation-agency.model';

export interface FleetOwnershipResourceLike {
    resourceOwnershipType?: string | null;
    transporterCrmClientName?: string | null;
    rentalVendorName?: string | null;
    resourceCompanyName?: string | null;
    currentTransportationAgency?: TransportationAgency | null;
    transportationAgency?: TransportationAgency | null;
}

function clean(value?: string | null): string | null {
    const normalized = String(value || '').trim();
    return normalized ? normalized : null;
}

export function fleetResourceOwnershipTypeLabel(resource?: FleetOwnershipResourceLike | null): string {
    switch ((resource?.resourceOwnershipType || '').toUpperCase()) {
        case 'OWNED':
            return 'Owned';
        case 'FREELANCE':
            return 'Freelance';
        case 'RENTAL':
            return 'Rental';
        case 'TRANSPORTER':
            return 'Transporter';
        default:
            return 'External';
    }
}

export function fleetResourceAgencyName(resource?: FleetOwnershipResourceLike | null): string | null {
    return clean(resource?.transportationAgency?.agencyName) || clean(resource?.currentTransportationAgency?.agencyName);
}

export function fleetResourceOwnerLabel(resource?: FleetOwnershipResourceLike | null): string {
    return clean(resource?.transporterCrmClientName)
        || clean(resource?.rentalVendorName)
        || fleetResourceAgencyName(resource)
        || clean(resource?.resourceCompanyName)
        || '-';
}

export function fleetResourceAgencyLabel(resource?: FleetOwnershipResourceLike | null): string | null {
    const agency = fleetResourceAgencyName(resource);
    return agency && agency !== fleetResourceOwnerLabel(resource) ? agency : null;
}

export function fleetResourceSourceCompanyLabel(resource?: FleetOwnershipResourceLike | null): string | null {
    const company = clean(resource?.resourceCompanyName);
    const owner = fleetResourceOwnerLabel(resource);
    const agency = fleetResourceAgencyLabel(resource);
    if (!company || company === owner || company === agency) {
        return null;
    }
    return company;
}

export function fleetResourceOwnershipSearchText(resource?: FleetOwnershipResourceLike | null): string {
    return [
        fleetResourceOwnershipTypeLabel(resource),
        fleetResourceOwnerLabel(resource),
        fleetResourceAgencyLabel(resource),
        fleetResourceSourceCompanyLabel(resource)
    ].filter(Boolean).join(' ');
}
